import { component } from 'picoapp';
import Swiper from 'swiper';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const tabBtns = node.querySelectorAll('.js-tabBtn');
  const imageElements = node.querySelectorAll('.js-image');
  const contentElements = node.querySelectorAll('.js-content');
  const desktopNavigationSliderElement = node.querySelector('.js-desktopNavigationSlider');
  const mobileNavigationSliderElement = node.querySelector('.js-mobileNavigationSlider');

  const config = JSON.parse(node.dataset.config);
  const { lastButtonIndex, navigationStyle } = config;

  const desktopNavigationSlider = desktopNavigationSliderElement ? new Swiper(desktopNavigationSliderElement, { // eslint-disable-line
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 60,
    initialSlide: lastButtonIndex, // We only use desktop slider if navigationStyle == 'timeline'
    threshold: 5,
  }) : null;

  const mobileNavigationSlider = new Swiper(mobileNavigationSliderElement, {
    slidesPerView: 'auto',
    centeredSlides: true,
    initialSlide: navigationStyle === 'timeline' ? lastButtonIndex : 0,
    threshold: 5,
  });

  /**
   * Functions
   */
  const update = (index) => {
    desktopNavigationSlider?.slideTo(index);
    mobileNavigationSlider.slideTo(index);

    tabBtns.forEach((btn) => {
      btn.disabled = true;

      if (btn.dataset.index === index) {
        btn.classList.add('image-tabs__button--active');
      } else {
        btn.classList.remove('image-tabs__button--active');
      }
    });

    imageElements.forEach((image) => {
      image.classList.remove('image-tabs__image--active');
    });

    const currentImages = Array.from(imageElements).filter((image) => image.dataset.index === index); // eslint-disable-line

    currentImages.forEach((image) => image.classList.add('image-tabs__image--active'));

    contentElements.forEach((content) => {
      if (content.dataset.index === index) {
        content.hidden = false;
      } else {
        content.hidden = true;
      }
    });

    tabBtns.forEach((btn) => {
      btn.disabled = false;
    });
  };

  const initTabBtns = () => {
    contentElements.forEach((element) => {
      Array.from(element.children).forEach((child, index) => {
        child.style.animationDelay = `${index * 300}ms`;
      });
    });

    tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => update(btn.dataset.index));
    });
  };

  /**
   * Init
   */
  initTabBtns();
});
